module.exports = __webpack_public_path__ + "img/main-site-ico-01.e5c18307.svg";